<template>
<div>
    <basicSearchUI :enableSearch = searchPortConfig.enableSearch 
                    :items = portExpectList.viewNodes
                    v-on:getData = handleData 
                    :tableFields = portExpectFields 
                    :search = searchExpect 
                    :rowClick=rowDetail>
        <portExpectSearchDetail slot="detailSearch"></portExpectSearchDetail>        
    </basicSearchUI>
    <b-modal ref="modal_error"  hide-footer title="錯誤">
      <p class="my-4">請「重新整理頁面」 或 「稍後重新查詢」</p>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">X</b-btn>
    </b-modal>
    <b-modal ref="modal_shipDetail" size="lg" hide-footer title="詳細資料">
      <b-container>
        <b-row>
          <b-col>
              <b-input-group>
                  <b-btn class="m-1" @click="See(aisLink)">AIS</b-btn>
              </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>{{"船名："}}</b-col>
          <b-col>{{ modalDetail.content["船名"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"英文名稱："}}</b-col>
          <b-col>{{ modalDetail.content["英文名稱"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"總噸："}}</b-col>
          <b-col>{{ modalDetail.content["毛重"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"代理公司："}}</b-col>
          <b-col>{{ modalDetail.content["代理公司"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"港口："}}</b-col>
          <b-col>{{ modalDetail.content["港口"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"上/下一港："}}</b-col>
          <b-col>{{ modalDetail.content["上/下一港"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"目的："}}</b-col>
          <b-col>{{ modalDetail.content["目的"]}}</b-col>
        </b-row>
        
        <b-row>
          <b-col>{{"實際進出港時間："}}</b-col>
          <b-col>{{ modalDetail.content["實際進出港時間"]}}</b-col>
        </b-row>

        

        <b-row>
          <b-col>{{"----"}}</b-col>
          <b-col>{{"----"}}</b-col>
        </b-row>
        
        <b-row>
          <b-col>{{"簽證編號"}}</b-col>
          <b-col>{{ modalDetail.content["簽證編號"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"預計進出港時間:"}}</b-col>
          <b-col>{{ modalDetail.content["預計進出港時間"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"預計靠泊時間:"}}</b-col>
          <b-col>{{ modalDetail.content["預計靠泊時間"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"預計離泊時間:"}}</b-col>
          <b-col>{{ modalDetail.content["預計離泊時間"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"船類型:"}}</b-col>
          <b-col>{{ modalDetail.content["船類型:"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"長度:"}}</b-col>
          <b-col>{{ modalDetail.content["長度"]}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{"SPS:"}}</b-col>
          <b-col>{{ modalDetail.content["SPS"]}}</b-col>
        </b-row>

      </b-container>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModalShipDetail">X</b-btn>
    </b-modal>
</div>
</template>

<script>
import portExpectSearchDetail from "./portExpectSearchDetail.vue"
import basicSearchUI from "./basicSearchUI.vue"
const tpeSearch = require('../lib/tpeSearch/tpeSearch');
const Moment = require('moment');

//https://github.com/rotaready/moment-range#node--npm
const MomentRange = require('moment-range');
const moment = MomentRange.extendMoment(Moment);

export default {
  name: "portExpect",
  components:{
    portExpectSearchDetail,
    basicSearchUI
  },
  data () {
    return {
        portExpectFields: [
        { key: '船名', sortable: true },
        { key: '港口', sortable: true },
        { key: '預報', sortable: true },
        { key: '預計', sortable: true },
        { key: '實際', sortable: true }
      ],
      portExpectList:{
        viewNodes:[],
      },
      searchPortConfig : {
        enableSearch: false,
        report : "InPortShipList",
        arg : {
          selectPort: "KEL",
          visaNo: undefined,
          special01: "False",
          special02: "False",
          spArrvDtFrom: "2018/07/26 00:00",
          spArrvDtTo: "2018/07/27 00:00",
          inoutPort: "進港"
        }
      },
      modalDetail: { title: '', content: '' },
      aisLink:""
    }
  },

  computed: {

  },
  methods:{
    handleData: function(getData) {
      this.searchPortConfig.arg = getData
    },

    searchExpect: function(getData){
      console.log(getData)

      this.searchPortConfig.arg = getData

      if(this.searchPortConfig.arg.inoutPort == "進港"){
        this.searchPortConfig.report = "InPortShipList" 
      }else if(this.searchPortConfig.arg.inoutPort == "出港"){
        this.searchPortConfig.report = "OutPortShipList"
      }

      this.portExpectList.viewNodes = []
      var e = this
      var url = tpeSearch.tpeUrl.getUrlFromPort(this.searchPortConfig)

      
      tpeSearch.tpeUrl.getJsonListFromUrl(url,

        function(){
          e.searchPortConfig.enableSearch = true
        },
        function(result){
          console.log(result)
          if(result!=null && result.ships!=undefined){
              result.ships["資料"].forEach(function(ship){
                
                //檢驗時間是否與查詢條件相符
                var startMoment = moment(e.searchPortConfig.arg.spArrvDtFrom,"YYYY/MM/DD h:mm")
                var endMoment = moment(startMoment).add(1,'days')
                var range = moment().range(startMoment, endMoment)
                var expecMoment = moment(ship['預計進出港時間'],"YYYYMMDDh:mm")
                
                if(ship['預計進出港時間']!="" && range.contains(expecMoment)){
                  var expect = ship['預計進出港時間'];
                  var act = ship['實際進出港時間'];
                  var plan = "";
                  var planStr = "";
                  if(e.searchPortConfig.arg.inoutPort == "進港"){
                    plan = ship['預計靠泊時間'] 
                    planStr = '預計靠泊時間'
                  }else if(e.searchPortConfig.arg.inoutPort == "出港"){
                    plan = ship['預計離泊時間']
                    planStr = '預計離泊時間'
                  }

                  if(expect != ""){
                    expect = tpeSearch.dateFormat(ship['預計進出港時間'])
                     
                  }

                  if(plan != ""){
                    plan = tpeSearch.dateFormat(ship[planStr])
                    

                  }

                  if(act != ""){
                    act = tpeSearch.dateFormat(ship['實際進出港時間'])
                  }


                  var viewNode = {
                    '船名': ship['船名'],
                    '港口': ship['港口'],
                    '預報': expect,
                    '預計': plan,
                    '實際': act,
                    detail:ship
                  }
                    e.portExpectList.viewNodes.push(viewNode)
                }else{
                  //console.log(ship)
                }

            })
          }else{
            e.$refs.modal_error.show()
          }
          
          e.searchPortConfig.enableSearch = false
        }
      )
    },
    showModal () {
      this.$refs.modal_error.show()
    },
    hideModal () {
      this.$refs.modal_error.hide()
    },
    rowDetail (item,index,event){
      var shipDeail = Object.assign({}, item.detail);
      shipDeail["實際進出港時間"] = tpeSearch.dateFormat(shipDeail['實際進出港時間'])
      shipDeail["預計進出港時間"] = tpeSearch.dateFormat(shipDeail['預計進出港時間'])
      shipDeail["預計靠泊時間"] = tpeSearch.dateFormat(shipDeail['預計靠泊時間'])
      shipDeail["預計離泊時間"] = tpeSearch.dateFormat(shipDeail['預計離泊時間'])
      this.modalDetail.content  = shipDeail
      var shipname = this.modalDetail.content["英文名稱"].trim()
      if(shipname!=""){
        shipname = shipname.replace(".","")
        this.aisLink = 'https://www.vesselfinder.com/vessels?name='+shipname
      }


      this.$refs.modal_shipDetail.show()
     
    },
    hideModalShipDetail(){
      this.$refs.modal_shipDetail.hide()
    },
    See (e) {
        window.open(e)
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/portExpect.vue